import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Fine-print bullets. Driven by the copy deck plus the add-ons from
 * the catalog so the dollar amounts come from the live data.
 */
import { sans } from '../fonts.js';
import { formatCount, formatMoneyMinor, pickPrice } from './format.js';
export function FinePrint({ theme, copy, data }) {
    const items = [];
    // Surface each add-on as a plain line so the live numbers appear
    // under the grid without a static copy edit. We deliberately keep
    // this short — a merchant following up in the dashboard sees the
    // exact dollar at checkout.
    for (const a of data.addons) {
        const price = pickPrice(a.prices, 'monthly');
        if (price === undefined)
            continue;
        if (a.kind === 'extra_free_site') {
            items.push(`Need another Free site? ${formatMoneyMinor(price.amount_minor, price.currency)} a month for one more site.`);
        }
        else if (a.kind === 'page_loads_pack') {
            items.push(`Need more page loads on a paid site? ${formatCount(a.unit_value)} a month for ${formatMoneyMinor(price.amount_minor, price.currency)}, bought with a click.`);
        }
        else if (a.kind === 'orders_pack') {
            items.push(`Need more agent orders on a paid site? ${formatCount(a.unit_value)} a month for ${formatMoneyMinor(price.amount_minor, price.currency)}, bought with a click.`);
        }
    }
    for (const line of copy.finePrint)
        items.push(line);
    if (items.length === 0)
        return null;
    return (_jsx("ul", { style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: '8px 32px',
            ...sans,
            fontSize: 14,
            color: theme.muted,
        }, className: "pr-fine", children: items.map((t, i) => (_jsx("li", { style: {
                borderLeft: `2px solid ${theme.border}`,
                paddingLeft: 12,
            }, children: t }, i))) }));
}
//# sourceMappingURL=FinePrint.js.map